/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { PublishContext } from './publish-context/PublishContext'
import type { SelectionLevel } from './types'

const LevelSelection: React.FC = () => {
  const publishContext = useContext(PublishContext)
  const { t: translate } = useTranslation()
  const [selection, setSelection] = useState<SelectionLevel>('STUDY')

  useEffect(() => {
    publishContext?.setSelectionsData((data) => ({ ...data, selectionLevel: selection }))
  }, [selection])

  return (
    <div className="pdr-publish-level">
      <div className="title">
        <b>{translate('INSTRUCTIONS_HERE')}</b>
      </div>
      <div className="selection-wrapper">
        <label className="control-label">{translate('EMTF_LEVEL')}</label>
        <div className="level-selection">
          <input
            id="2a8de80f-4992-49bf-9203-faf3ab706158"
            className="level-radio"
            type="radio"
            name="level"
            value="STUDY"
            checked={selection === 'STUDY'}
            onClick={() => {
              setSelection('STUDY')
            }}
            onChange={() => {
              // Empty handler to prevent warning
            }}
          />
          <label className="level-value">{translate('EOS_SETUP_STUDY')}</label>
        </div>
        <div className="level-selection">
          <input
            id="9e5e5195-40bb-4422-bef6-b67ca3895bc6"
            className="level-radio"
            type="radio"
            name="level"
            value="SITE"
            checked={selection === 'SITE'}
            onClick={() => {
              setSelection('SITE')
            }}
            onChange={() => {
              // Empty handler to prevent warning
            }}
          />
          <label className="level-value">{translate('EMTF_MD_SITE')}</label>
        </div>
        <div className="level-selection">
          <input
            id="2c6846c6-b923-482a-bb69-dfd73d4e9f14"
            className="level-radio"
            type="radio"
            name="level"
            value="PATIENT"
            checked={selection === 'PATIENT'}
            onClick={() => {
              setSelection('PATIENT')
            }}
            onChange={() => {
              // Empty handler to prevent warning
            }}
          />
          <label className="level-value">{translate('PATIENT')}</label>
        </div>
      </div>
    </div>
  )
}

export default LevelSelection
